<script setup lang="ts">
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';

defineProps<FontAwesomeIconProps>();
</script>

<template>
  <FontAwesomeIcon v-bind="$props" />
</template>
